"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var image_1 = __importDefault(require("next/image"));
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var next_intl_1 = require("next-intl");
var MethodItem = function (_a) {
    var _b = _a.isActive, isActive = _b === void 0 ? false : _b, _c = _a.isActiveRecent, isActiveRecent = _c === void 0 ? false : _c, onClick = _a.onClick, isDisabled = _a.isDisabled, background = _a.background, logo = _a.logo, label = _a.label, slug = _a.slug, styles = _a.styles, name = _a.name;
    var t = (0, next_intl_1.useTranslations)('translation');
    var getPaymentImagePath = (0, react_1.useCallback)(function (methodSlug) { return "/img/payments/".concat(methodSlug, ".svg"); }, []);
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.container, " ").concat(isActive ? styles_module_scss_1.default.active : '', " ").concat(isActiveRecent ? styles_module_scss_1.default.activeRecent : ''), style: { background: background }, onClick: function () { return (!isDisabled ? onClick() : null); } },
        isActiveRecent && (react_1.default.createElement("div", { className: styles_module_scss_1.default.triangle },
            react_1.default.createElement("img", { src: "/img/icons/checkTriangle.svg" }))),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.fee }, t('zeroFee')),
        (label || (styles === null || styles === void 0 ? void 0 : styles.label)) && (react_1.default.createElement("div", { className: styles_module_scss_1.default.label }, label || (styles === null || styles === void 0 ? void 0 : styles.label))),
        logo ? (react_1.default.createElement("img", { src: logo, width: 118, height: 32, className: styles_module_scss_1.default.image })) : (react_1.default.createElement(image_1.default, { src: getPaymentImagePath(slug), width: 118, height: 32, alt: slug, className: styles_module_scss_1.default.image })),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.name }, name)));
};
exports.default = MethodItem;
